import { render, staticRenderFns } from "./SelecionarArquivoPlanilha.vue?vue&type=template&id=421b986e&scoped=true&lang=pug"
import script from "./SelecionarArquivoPlanilha.vue?vue&type=script&lang=js"
export * from "./SelecionarArquivoPlanilha.vue?vue&type=script&lang=js"
import style0 from "./SelecionarArquivoPlanilha.vue?vue&type=style&index=0&id=421b986e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b986e",
  null
  
)

export default component.exports